// Toast: krátká zpráva vpravo dole, sama zmizí. Historie zůstává v centru oznámení (shell).
import { h } from '../dom';
import { icon } from '../icons';
import { tk } from '../i18n';

export type ToastKind = 'info' | 'ok' | 'warn' | 'error';

export interface ToastRecord {
  text: string;
  kind: ToastKind;
  at: Date;
}

const history: ToastRecord[] = [];
let listeners: ((r: ToastRecord) => void)[] = [];

/** @param onClick klik na hlášku něco otevře (např. novou zprávu); bez něj klik hlášku jen zavře */
/** Hláška s tlačítkem akce (např. „Zpět“ po smazání); zmizí po $ms. */
export function toastAction(text: string, kind: ToastKind, action: { label: string; onClick: () => void }, ms = 7000): void {
  toast(text, kind, ms, undefined, action);
}

/** Chyba z API (text i jeho parametry – jinak by v hlášce zůstalo {n}, {name}…). */
export function toastError(e: unknown): void {
  const err = e as { message?: string; params?: Record<string, unknown> | null };
  toast(tk(err.message ?? 'core.err.internal', (err.params ?? undefined) as Record<string, string | number> | undefined), 'error');
}

export function toast(text: string, kind: ToastKind = 'info', ms = kind === 'error' ? 8000 : 3500, onClick?: () => void, action?: { label: string; onClick: () => void }): void {
  let host = document.querySelector<HTMLElement>('.toast-host');
  if (!host) {
    host = h('div', { class: 'toast-host', role: 'status', 'aria-live': 'polite' });
    document.body.appendChild(host);
  }
  const actBtn = action ? h('button', { type: 'button', class: 'toast-action' }, action.label) as HTMLButtonElement : null;
  const el = h('div', { class: 'toast ' + kind + (onClick ? ' clickable' : '') }, icon(kind === 'ok' ? 'check' : kind === 'error' ? 'warning' : kind === 'warn' ? 'warning' : 'info'), h('span', null, text), actBtn);
  host.appendChild(el);
  requestAnimationFrame(() => el.classList.add('show'));
  const remove = () => {
    el.classList.remove('show');
    window.setTimeout(() => el.remove(), 200);
  };
  const timer = window.setTimeout(remove, ms);
  el.addEventListener('click', (ev) => {
    // hláška se „Zpět“: klik mimo tlačítko ji nezavře (Zpět by se ztratilo)
    if (actBtn && !onClick && !(ev.target instanceof Node && actBtn.contains(ev.target))) return;
    window.clearTimeout(timer);
    remove();
    if (actBtn && ev.target instanceof Node && actBtn.contains(ev.target)) action?.onClick();
    else onClick?.();
  });
  const rec: ToastRecord = { text, kind, at: new Date() };
  history.unshift(rec);
  if (history.length > 50) history.pop();
  for (const l of listeners) l(rec);
}

export function toastHistory(): ToastRecord[] {
  return history;
}

export function onToast(l: (r: ToastRecord) => void): () => void {
  listeners.push(l);
  return () => {
    listeners = listeners.filter((x) => x !== l);
  };
}
